import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import ConsolePage from './console/ConsolePage';
import HomePage from './home/HomePage';
import InternalLayout from './internal/InternalLayout';
import LiveDemoPage from './live-demo/LiveDemoPage';
import './styles/global.css';
import { AdmissionsLeadsProvider } from './context/AdmissionsLeadsContext';

export default function AdmissionsAssured() {
  return (
    <AdmissionsLeadsProvider><div className="admissions-assured">
      <Routes>
        <Route index element={<HomePage />} />
        <Route path="v2" element={<ConsolePage variant="v2" />} />
        <Route path="live-demo" element={<LiveDemoPage />} />
        <Route path="internal/:pageId" element={<InternalLayout />} />
      </Routes>
    </div></AdmissionsLeadsProvider>
  );
}
